import React from 'react';
import { Input } from '@/components/ui/input';

export const fmtDob = (v) => {
  const d = String(v || '').replace(/\D/g, '').slice(0, 8);
  return [d.slice(0, 2), d.slice(2, 4), d.slice(4)].filter(Boolean).join('-');
};

/** Date of birth typed as DD-MM-YYYY — dashes are added automatically, number keypad on phones. */
export const DobInput = ({ value, onChange, ...rest }) => (
  <Input inputMode="numeric" autoComplete="off" placeholder="DD-MM-YYYY" maxLength={10} value={value}
    onChange={(e) => onChange(fmtDob(e.target.value))} className="h-12 text-lg font-mono tracking-wider" {...rest} />
);

export default DobInput;
